import { appFetch } from './fetch';
import host from './host';
import auth from './auth';

export const getFailures  = async () => {
    const url = `${host}/failures/get_all`;
    return await appFetch({ url, auth: auth.getToken(), method: 'GET' });
};

export const createFailure = async data => {
    const url = `${host}/failure/create`;
    return await appFetch({ url, auth: auth.getToken(), body: JSON.stringify(data), method: 'POST' })
}

export const updateFailure = async (id, data) => {
    const url = `${host}/failure/update/${id}`;
    return await appFetch({ url, auth: auth.getToken(), body: JSON.stringify(data), method: 'PUT' })
}